import { Lavorazione } from './Lavorazione';
import { LavorazioneSlim } from './LavorazioneSlim';
import { LavorazionePerSpedizione } from './LavorazionePerSpedizione';
import { ProgressoSpedizione } from './ProgressoSpedizione';

export const Mapper = {
    LavorazioneToLavorazioneSlim(lavorazione: Lavorazione) : LavorazioneSlim {
        let slim: LavorazioneSlim = {
            id: lavorazione.id,
            stato: lavorazione.stato,
            lotto: lavorazione.lotto,
            ordineLinea: lavorazione.innerLavorazione.ordineLinea,
            ordineNumero: lavorazione.innerLavorazione.ordineNumero,
            codiceConsegna: lavorazione.codiceConsegna,
            codiceLAK: lavorazione.codiceLAK,
            dataOrdine: lavorazione.dataOrdine,
            dataConsegna: lavorazione.dataConsegna,
            dataRientro: lavorazione.dataRientro,
            campionario: lavorazione.campionario,
            firstCost: lavorazione.firstCost,
            fornitore: lavorazione.fornitore,
            progresso: lavorazione.progresso,
            qtaTotale: lavorazione.qtaTotale,
            modello: lavorazione.modelloDecodificato,
            colore: lavorazione.coloreDecodificato,
            fase: lavorazione.faseDecodificata,
            lineaVendita: lavorazione.lineaVenditaDecodificata,
            stagione: lavorazione.stagioneDecodificata,
            note: lavorazione.note
        };

        return slim;
    },

    LavorazionePerSpedizioneToProgressoSpedizione(lavorazioneSped: LavorazionePerSpedizione) : ProgressoSpedizione {
        let prog: ProgressoSpedizione = {
            indice: 0,
            stato: '',
            idLavorazione: lavorazioneSped.id,
            idSpedizione: '',
            ordineNumero: lavorazioneSped.ordineNumero,
            ordineLinea: lavorazioneSped.ordineLinea,
            tipoTaglie: lavorazioneSped.tipoTagliaDecodificato,
            qtaTaglia01: lavorazioneSped.qtaProdottaNonSpeditaTaglia01,
            qtaTaglia02: lavorazioneSped.qtaProdottaNonSpeditaTaglia02,
            qtaTaglia03: lavorazioneSped.qtaProdottaNonSpeditaTaglia03,
            qtaTaglia04: lavorazioneSped.qtaProdottaNonSpeditaTaglia04,
            qtaTaglia05: lavorazioneSped.qtaProdottaNonSpeditaTaglia05,
            qtaTaglia06: lavorazioneSped.qtaProdottaNonSpeditaTaglia06,
            qtaTaglia07: lavorazioneSped.qtaProdottaNonSpeditaTaglia07,
            qtaTaglia08: lavorazioneSped.qtaProdottaNonSpeditaTaglia08,
            qtaTaglia09: lavorazioneSped.qtaProdottaNonSpeditaTaglia09,
            qtaTaglia10: lavorazioneSped.qtaProdottaNonSpeditaTaglia10,
            qtaTaglia11: lavorazioneSped.qtaProdottaNonSpeditaTaglia11,
            qtaTaglia12: lavorazioneSped.qtaProdottaNonSpeditaTaglia12,
            qtaTaglia13: lavorazioneSped.qtaProdottaNonSpeditaTaglia13,
            qtaTaglia14: lavorazioneSped.qtaProdottaNonSpeditaTaglia14,
            qtaTaglia15: lavorazioneSped.qtaProdottaNonSpeditaTaglia15,
            qtaTaglia16: lavorazioneSped.qtaProdottaNonSpeditaTaglia16
        };
        
        return prog;
    }
}